/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 45px;
  margin-bottom: ${props => (props.marginBottom ? '45px' : '0')};
  
  p {
    font-size: 11px;
    color: #999999;
  }

  span {
    text-transform: uppercase;
    font-weight: 700;
  }
`;
